import { practicalStep, type TourStep } from "./runTour"

/**
 * Walks the "admin ve un resumen consolidado para tomar decisiones" story
 * (openspec/changes/gestion-panel-user-stories, gestion-admin-dashboard-visibility)
 * against the real Dashboard/Home.tsx page. Ends with a real, hands-on click
 * through to the institution registry — proving that piece of the story
 * genuinely works, instead of just describing it.
 */
export const adminVisibilityTourSteps: TourStep[] = [
  {
    popover: {
      title: "Tutorial práctico: visibilidad para admin",
      description:
        "Recorre lo que hoy existe para que el admin tome decisiones sin entrar módulo por módulo, y termina con un clic real para comprobar una de las piezas.",
    },
  },
  {
    element: '[data-tour="home-metrics"]',
    popover: {
      title: "KPIs de hoy",
      description:
        "Entregas por calificar, equipos CCCD en negociación/pago pendiente, equipos confirmados, progreso promedio. Son alertas accionables, no un resumen por organización o semillero.",
      side: "bottom",
    },
  },
  {
    element: '[data-tour="home-project-academia"]',
    popover: {
      title: "Proyectos: Academia",
      description: "Navegación directa a Cursos, Semilleros y Programas — no muestra conteos por estado aquí.",
      side: "top",
    },
  },
  {
    element: '[data-tour="home-project-cccd"]',
    popover: {
      title: "Proyectos: CCCD",
      description: "Igual que Academia: navegación, no un resumen de pagos por estado (pending/approved/declined).",
      side: "top",
    },
  },
  {
    popover: {
      title: "Lo que falta (gap real)",
      description:
        "No hay conteo de organizaciones/semilleros por estado (active/paused/archived), ni de miembros por SeedbedEnrollmentStatus, ni de pagos separados Academy vs. CCCD por estado, ni un indicador de \"semillero sin actividad reciente\". Hoy este panel es de navegación y alertas puntuales, no el resumen consolidado que la historia de usuario pide.",
    },
  },
  practicalStep({
    element: '[data-tour="home-quick-links"] a[href="/programs/institutions"]',
    popover: {
      title: "👉 Hazlo tú: comprueba el registro de organizaciones",
      description:
        'Haz clic en "Organizaciones" — te lleva de verdad a Programs → Organizaciones. Ese flujo de registro sí existe y funciona; confírmalo creando o revisando una organización ahí.',
      side: "top",
    },
  }),
]
